<template>
  <snake-game />
</template>

<script>
import SnakeGame from "../components/SnakeGame.component";

export default {
  name: "Snake.container",
  components: {
    SnakeGame
  }
};
</script>

<style scoped></style>
